export const DownArrow: React.FC = () => {
  return (
    <svg width="29" height="107" viewBox="0 0 29 107" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M23.2653 97C15.2653 85 10.3903 75.5 6.26528 63C-0.353572 42.9429 -4.50073 11.5163 19 1M17.7653 99.5L26.2653 104.5L27.7653 88" stroke="#8750D7" stroke-width="2"/>
    </svg>
  );
};
